
import {
  schema, normalize
} from 'normalizr';

// Define rating schema
const ratingSchema = new schema.Entity('ratings')
const ratingListSchema = [ratingSchema]

export function adaptRatingsToStore(response) {
  const apiData = response.data
  const apiResults = apiData.results ? apiData.results : apiData
  const entries = normalize(apiData, ratingListSchema)
  return {
    entries: entries.entities.ratings,
    count: apiData.count ? apiData.count : apiData.length,
    next: apiData.next ? apiData.next : '',
    previous: apiData.previous ? apiData.previous : '',
    results: apiResults
  }
}

export function adaptRatingsDownload(response) {
  const filename = response.headers['content-disposition'].split('filename=')[1].split(';')[0].replace(/['"]/g, '')
  return {
    data: response.data,
    filename: filename
  }
}

export function adaptSummaryToStore(response) {
  const apiData = response.data
  return apiData
}